import Setup from './setup';

export default {
    Setup
}